Vue.component('targets', {
    props: ['types', 'client-id'],

    data () {
        return {
            loading: true,

            working: false,

            targets: {},

            test: {
                a: '',
                b: ''
            }
        };
    },

    mounted () {
        this.loadTargets();

        console.log();
    },

    methods: {
        updateDom () {
            this.$forceUpdate();
        },

        loadTargets () {
            this.loading = true;

            axios.get('/api/targets', {
                params: {
                    client_id: this.clientId
                }
            }).then((response) => {
                for (let target of response.data.targets) {
                    target.dashboard_enabled = Number(target.dashboard_enabled);
                    this.targets[target.type.toLowerCase()] = target;
                }

                for (let type of this.targetTypes) {
                    if (this.targets[type.toLowerCase()] === undefined) {
                        this.targets[type.toLowerCase()] = {
                            monthly_target: 0,
                            yearly_target: 0,
                            dashboard_enabled: 0,
                            target_against: '',
                            type
                        };
                    }
                }

                this.loading = false;
            });
        },

        submit () {
            this.working = true;

            axios.post('/api/targets/save', JSON.stringify(this.targets), {
                params: {
                    client_id: this.clientId
                }
            }).then((response) => {
                this.working = false;
            });
        }

    },

    computed: {
        targetTypes () {
            let targetTypes = this.types.filter((type) => {
                return type !== 'Other';
            });

            targetTypes.push('Total');

            return targetTypes;
        }
    }
});